// extracted by mini-css-extract-plugin
export default {"note":"AppointmentSummaryNote_note__U72hp","date-txt":"AppointmentSummaryNote_date-txt__O3cZZ"};